<script>
  export let isOpen = false;
</script>

{#if isOpen}
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show" tabindex="-1" style="display: block;">
    <slot />
  </div>
{/if}
